'use strict';
var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/internals/html.js
// module id = 346
// module chunks = 22